import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { useFormikContext } from 'formik';
import { SuggesetionField } from '@features/tsp/suggest';
import { withTheme } from '@shared/lib/theme';
import { Button } from '@shared/ui/molecules';
import { Text } from '@shared/ui/atoms';
import { CrossIcon } from '@shared/assets/icons';
import suggestModalTopImage from '../assets/suggest-modal-top-image.webp';
interface SuggestionNotSentContentProps {
  onClose: () => void;
}
const SuggestionNotSentContent: FC<SuggestionNotSentContentProps> = ({
  onClose
}) => {
  const {
    isSubmitting
  } = useFormikContext();
  return <>
      <ImageWrapper>
        <Image src={suggestModalTopImage} alt="Предложка" width={600} height={200} />
      </ImageWrapper>
      <ContentWrapper>
        <IconButtonWrapper type="button" onClick={onClose}>
          <CrossIcon />
        </IconButtonWrapper>
        <TextWrapper>
          <Text size={{
          desktop: 'h4',
          mobile: 'h6'
        }} weight="bold">
            Предложка
          </Text>
          <Text size={{
          desktop: 'h6',
          mobile: 'pM'
        }} family="MTSCompact" color="secondary">
            Здесь вы можете предложить любимую игру или сервис, которых у нас пока нет
          </Text>
        </TextWrapper>
        <FieldWrapper>
          <SuggesetionField placeholder="А давайте добавим..." />
        </FieldWrapper>
        <Button type="submit" size={{
        desktop: '72',
        mobile: '52'
      }} isLoading={isSubmitting}>
          Отправить
        </Button>
      </ContentWrapper>
    </>;
};
export default SuggestionNotSentContent;
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "ituecn5",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1uymtuj",
  propsAsIs: false,
  vars: {
    "c1uymtuj-0": [_exp()]
  }
}));
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "i1g1ig3",
  propsAsIs: false,
  vars: {
    "i1g1ig3-0": [_exp2()]
  }
}));
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t3oxk4b",
  propsAsIs: false
});
const FieldWrapper = /*#__PURE__*/styled('div')({
  name: "FieldWrapper",
  class: "f1258iat",
  propsAsIs: false
});

require("./SuggestionNotSentContent.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SuggestionNotSentContent.tsx");